import {
	CreateEquipmentColumnRequest,
	EquipmentColumnDto,
	EquipmentRecordDto,
	CreateEquipmentRequest,
	UpdateEquipmentRequest,
} from '../types/Equipment/FleetEquipmentLog'
import { deleteOne, getAll, postWithResponse, put } from './CommonServices/httpService'

export const listEquipment = async () => {
	const result = await getAll<EquipmentRecordDto[]>(`/Equipment`)
	return result.data
}

export const listEquipmentColumns = async () => {
	const result = await getAll<EquipmentColumnDto[]>(`/Equipment/columns`)
	return result.data
}

/** Lowercase keys for default columns removed from the grid (e.g. itemcode, unitprice). */
export const listHiddenColumns = async () => {
	const result = await getAll<string[]>(`/Equipment/hidden-columns`)
	return result.data
}

export const createEquipmentColumn = async (request: CreateEquipmentColumnRequest) => {
	const result = await postWithResponse<number>(`/Equipment/columns`, request)
	return result.data
}

export const deleteEquipmentColumn = async (columnId: number) => {
	const result = await deleteOne(`/Equipment/columns/${columnId}`)
	return result.success
}

export const deleteCommonEquipmentColumn = async (commonColumnName: string) => {
	const result = await deleteOne(
		`/Equipment/columns?commonColumnName=${encodeURIComponent(commonColumnName)}`,
	)
	return result.success
}

export const bulkCreateEquipment = async (requests: CreateEquipmentRequest[]) => {
	const result = await postWithResponse<number[]>(`/Equipment`, requests)
	return result.data
}

export const bulkUpdateEquipment = async (requests: UpdateEquipmentRequest[]) => {
	const result = await put(`/Equipment`, requests)
	return result.success
}

export const setEquipmentStatus = async (equipmentId: number, isActive: boolean) => {
	const result = await put(`/Equipment/${equipmentId}/status`, { isActive })
	return result.success
}

export const deleteEquipment = async (equipmentId: number) => {
	const result = await deleteOne(`/Equipment/${equipmentId}`)
	return result.success
}
